import './style/bluemateTabs.scss';

import classNames from 'classnames';

import React from 'react';

import {BluemateTabsVariant} from '../../../util/types';

import {BluemateTab} from '../../../util/interfaces';

interface Props<T extends string | number = string> {
    tabs: Array<BluemateTab<T>>;
    activeTab: T;
    onChangeTab: (tab: T, event: React.MouseEvent) => void;
    variant?: BluemateTabsVariant;
    className?: string;
}

export default function BluemateTabs<T extends string | number = string>(props: Props<T>) {
    const {tabs, activeTab, onChangeTab, variant = 'underline', className} = props;

    function handleClick(tab: T) {
        return function (event: React.MouseEvent) {
            if (tab !== activeTab) onChangeTab(tab, event);
        };
    }

    return (
        <div className={classNames('bluemate-tabs', `variant-${variant}`, className)}>
            {tabs.map(tab => (
                <div
                    key={tab.key}
                    className={classNames('bluemate-tab', activeTab === tab.key && 'active')}
                    onClick={handleClick(tab.key)}
                >
                    <label className='bluemate-tab-label'>{tab.label}</label>
                </div>
            ))}
        </div>
    );
}
